import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import SiteProcessActions from '../../Stores/SiteProcess/Actions';

import SiteList01Table from '../SiteList01/SiteList01Table';
import SiteFlowList01Table from '../SiteFlowList01/SiteFlowList01Table';

const { TabPane } = Tabs;

class SiteProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, fetchSiteProcess } = this.props;
    if (curSiteFlowId > 0) {
      fetchSiteProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, fetchSiteProcess } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        fetchSiteProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/siteProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'SITE_LIST_01' && <SiteList01Table match={match} />}
        {match.params.proc_type === 'SITE_FLOW_LIST_01' && <SiteFlowList01Table match={match} />}
      </Card>
    );
  }
}

SiteProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchSiteProcess: PropTypes.func
};

SiteProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curSiteFlowId: 0,
  fetchSiteProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.siteProcess.process,
  processIsLoading: state.siteProcess.processIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  fetchSiteProcess: () => dispatch(SiteProcessActions.siteProcessFetchSiteProcess())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SiteProcessScreen));
